import Cookies from 'js-cookie';

export const tokenName = 'snake_oil_access_token_cookie';

export const setAuthToken = (token: string) => {
    Cookies.set(tokenName, token);
};

export const getAuthToken = () => {
    const token = Cookies.get(tokenName);
    return token;
};

export const removeAuthToken = () => Cookies.remove(tokenName);
